import request from './AxiosRequest';

const add = params =>
	request({
		method: 'POST',
		url: '/Services/api/reblast/save',
		data: params
	});

const deleteReblast = reblastId =>
	request({
		method: 'POST',
		url: '/Services/MainService.svc/json/SaveReblast',
		data: {
			reblast: {
				Identifier: reblastId,
				Delete: true
			}
		}
	});

const SaveReblast = {
	add,
	delete: deleteReblast
};

export default SaveReblast;
